module.exports = __webpack_public_path__ + "static/media/vf_wskirt_core.767c56f5.svg";